import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { useTaskStatusTrendSummary } from '../../Hooks/Features/ProjectDashboard/useTaskStatusTrendSummary'
import { SkeletonContainer } from '../Loader/Loader'
import { Dropdown } from 'primereact/dropdown';
import DatePicker from 'react-multi-date-picker';

const TaskStatusTrendSummary = () => {

    const {  taskStatusTrendData, loader, dropdownOption, filterData, setFilterData, getTaskStatusTrendSummary } = useTaskStatusTrendSummary()


    const options = {
        credits: { enabled: false },
        chart: {
            type: 'line'
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: taskStatusTrendData?.xAxis,
            title: { text: '' }
        },
        yAxis: {
            type: 'number',
            min: taskStatusTrendData?.min,
            max: taskStatusTrendData?.max,
            tickInterval: taskStatusTrendData?.tickInterval,
            title: {
                text: ''
            },
        },
        legend: {
            enabled: true,
            verticalAlign: 'top',
        },
        series: taskStatusTrendData?.data
    };

    return (
        <div className="w100" style={{ height: "100%" }}>

            <div className="card-container">
                <div className='d-flex justify-content-between'>
                    <span style={{ fontSize: "14px", fontWeight: "600" }}> Task Status</span>
                    <div className="d-flex gap-1 w70">
                        <div className='w60'>
                            <DatePicker
                                value={""}
                                onChange={(e) => {
                                    setFilterData((prev) => ({ ...prev, hoveredRange: e, isChange: true }))
                                }}
                                range
                                rangeHover
                                numberOfMonths={2}
                                placeholder="Select Dates"
                                onClose={() => {
                                    if (filterData?.isChange) { getTaskStatusTrendSummary() }
                                }}
                            />
                        </div>
                        <div className='w40'>
                            <Dropdown
                                onChange={(e) => setFilterData((prev) => ({ ...prev, type: e.value, isChange: true }))}
                                options={dropdownOption}
                                filter
                                filterInputAutoFocus
                                placeholder="Type"
                                value={filterData?.type}
                                optionLabel="name"
                                onHide={() => {
                                    if (filterData?.isChange) { getTaskStatusTrendSummary() }
                                }}
                                name="type"
                            />
                        </div>
                    </div>
                </div>
                <div style={{ height: "95%" }}>
                    {
                        loader ? <div style={{ height: "inherit" }}>
                            <SkeletonContainer />
                        </div> :

                            taskStatusTrendData?.data?.length > 0 ? <HighchartsReact highcharts={Highcharts} options={options} containerProps={{
                                style: {
                                    height: "inherit",
                                },
                            }} /> : <div className="w100 d-flex justify-content-center align-items-center" style={{ height: "inherit" }}>
                                <div className='text-center'>
                                    <img src={"./assets/nodata.jpg"} alt='no data' />
                                    <p className=' red mt-3'> Data Not Found</p>
                                </div>
                            </div>


                    }
                </div>
            </div>
        </div>
    )
}

export default TaskStatusTrendSummary